import React from 'react';

const ColumnTitle = (props) => {
    return (
        <label className="clickable custom">
            <span onClick={() => props.orderColumn(props.columnIndex)}>{props.title}
                {props.order == false && props.icon == false ?
                    <i className="glyphicon glyphicon-triangle-bottom"></i>
                    : (props.order == true && props.icon == false) ?
                        <i className="glyphicon glyphicon-triangle-top"></i>
                        : <i className={"glyphicon glyphicon-triangle-bottom " + ((props.order == true) ? "current" : "")}></i>}
            </span>
        </label>
    );
}

export default ColumnTitle;